<template>
    <Upload :before-upload="upImg" action="/">
        <slot>
            <a>{{btn_name || $t('upload')}}</a>
        </slot>
    </Upload>
</template>

<script>
    import lrz from "lrz";
    import 'iview/dist/styles/iview.css';
    import { Upload } from 'iview'

    let OSS = require('ali-oss');
    export default {
        name: "myUpImg",
        components:{
            Upload
        },
        props:{
            lrz_flag:{
                default: true,
                type: Boolean
            },
            lrz_quality:{
                default: 0.8,
                type: Number
            },

            //指定path 类型
            new_path:{
                default: '',
                type: String,
            },
            index_id:{ //本index_id 如果设了>=0 直接变成指定 path类型 指定ID存立即覆盖
                default: -1
            },
            level_id:{ //版本号 1和2之间切换 实现有不保存的情况 有index_id时使用
                default: '1'
            },

            max_size:{
                default: '20', //限制大小M
                type: String
            },
            row_index1:{ //data表格的行号
                default: -1
            },
            row_index2:{ //data表格的行号
                default: -1
            },
            btn_name:{
                default: '',
                type: String
            }
        },
        data:function(){
            return{
                client: null,
                path : `other/${this.$moment().format("YYYY-MM-DD")}/`,
            }
        },
        mounted: function () {
        },
        methods: {
            upImg: function (file) {
                var old_exs = file.name.split('.');
                if(old_exs.length < 2){
                    this.$base.alertErr(this.$t('file_type_err'));
                    return;
                }
                var old_ex = old_exs[old_exs.length - 1];
                if(!['jpg','jpeg','png','gif'].includes(old_ex)){
                    this.$base.alertErr(this.$t('file_type_err'));
                    return;
                }

                var size = file.size / 1024 / 1024;
                if(size > this.max_size){ //限制不能大于1M
                    this.$base.alertErr(this.$t('file_size_err') + '[' + this.max_size + 'M]');
                    return;
                }
                this.$base.getOssImgKey((key)=>{
                    this.$base.showLoading();
                    if(!this.client){
                        try{
                            this.client = new OSS(key);
                        }
                        catch (e){
                            this.$base.hideLoading();
                            this.$base.alertErr(this.$t('upload_err'));
                            return;
                        }
                    }
                    var self = this;
                    // 文件直接上传到阿里云oss
                    let fileNameLast = '';
                    if(this.lrz_flag){
                        fileNameLast = 'jpg';
                    }
                    else{
                        let fileNameArr = file.name.split('.');
                        fileNameLast = fileNameArr[fileNameArr.length - 1];
                    }
                    let fileNameStr = "";

                    var upd_level_id = 0;
                    if(this.index_id >= 0){
                        fileNameStr = this.index_id;

                        if(this.level_id == '1'){
                            fileNameStr += '_2';
                            upd_level_id = '2';
                        }
                        else{
                            fileNameStr += '_1';
                            upd_level_id = '1';
                        }
                    }
                    else{
                        fileNameStr = this.$moment().format("HHmmssSSS") + Math.ceil(Math.random() * 12345);
                    }

                    let fileName = "";
                    if(this.new_path != ''){
                        fileName = this.new_path + fileNameStr + '.' +fileNameLast;
                    }
                    else{
                        fileName = this.path + fileNameStr + '.' +fileNameLast;
                    }
                    fileName = key.dir + fileName;

                    if(this.lrz_flag){
                        let option = {
                            width : 30000,
                            height: 'auto',
                            quality: this.lrz_quality
                        };

                        lrz(file, option).then((rst) => {
                            this.client.multipartUpload(fileName, rst.file).then(res => {
                                console.log('---1',res)
                                self.$base.hideLoading();
                                let url = res.res.requestUrls[0];
                                if(url.indexOf("?") != -1){
                                    url = url.split("?")[0];
                                }
                                self.$emit('onChange',{url,'upd_level_id':upd_level_id,'index_id':self.index_id,'row_index1':self.row_index1,'row_index2':self.row_index2});
                            }).catch(err => {
                                self.$base.hideLoading();
                                self.$base.alertErr(self.$t('upload_err'));
                            })
                        }).catch((error) => {
                            self.$base.alertErr(self.$t('upload_err'));
                        });
                    }
                    else{
                        this.client.multipartUpload(fileName, file).then(res => {
                            console.log('---2',res)
                            self.$base.hideLoading();
                            let url = res.res.requestUrls[0];
                            if(url.indexOf("?") != -1){
                                url = url.split("?")[0];
                            }
                            self.$emit('onChange',{url,'upd_level_id':upd_level_id,'index_id':self.index_id,'row_index1':self.row_index1,'row_index2':self.row_index2});
                        }).catch(err => {
                            self.$base.hideLoading();
                            self.$base.alertErr(self.$t('upload_err'));
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myUpImg.vue